import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getplanTrainingHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "plantraining", ...action.payload }),
		);
		yield put({
			type: types.GET_PLAN_TRAINING_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_PLAN_TRAINING_ERROR,
			payload,
		});
	}
}

export function* getplanTrainingWatcherSaga() {
	yield takeLatest(types.GET_PLAN_TRAINING_START, getplanTrainingHandlerSaga);
}

//create

//delete

function* deleteplanTrainingHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("plantraining", action.payload),
		);
		yield put({
			type: types.DELETE_PLAN_TRAINING_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_PLAN_TRAINING_ERROR,
			payload,
		});
	}
}

export function* deleteplanTrainingWatcherSaga() {
	yield takeLatest(
		types.DELETE_PLAN_TRAINING_START,
		deleteplanTrainingHandlerSaga,
	);
}

//update
